import React from 'react';

import { Routes } from 'routing';

import { useTranslation } from 'services/localization';
import SetPageNavAction from 'components/Portals/SetPageNavAction';
import SetPageTitle from 'components/Portals/SetPageTitle';
import LanguageSettings from './Tabs/LanguageSettings';
import Translations from './Tabs/Translations';
import TabContainer from 'components/nav/TabContainer';
import Container from 'components/Container';
import HasFeature from 'components/features/HasFeature';
import { Redirect } from 'react-router-dom';
import { useHasFeature } from 'hooks/useHasFeature';

const Languages = () => {
	const { t } = useTranslation();
	const { hasFeature } = useHasFeature();
	return (
		<HasFeature
			scope="user"
			requiredFeature="LANGUAGES"
			fallback={<Redirect to={Routes.ACCOUNT} />}
		>
			<SetPageTitle priority={2} title={t('account.languages.pageTitle', 'Languages')} />
			<SetPageNavAction
				priority={2}
				backAction={{ to: Routes.ACCOUNT, title: t('account.pageTitle', 'Account') }}
				quickLinks={[]}
			/>
			<Container>
				<TabContainer
					tabs={[
						{
							label: t('product.settings'),
							component: LanguageSettings,
							path: 'settings',
						},
						{
							label: t('account.languages.translationPlural', 'Translations'),
							component: Translations,
							path: 'translations',
							hidden: !hasFeature('LANGUAGES', {
								scope: 'user',
							}),
							locked: !hasFeature('LANGUAGES', {
								scope: 'shop',
							}),
						},
					]}
					basePath={Routes.ACCOUNT_LANGUAGES}
				/>
			</Container>
		</HasFeature>
	);
};
export default Languages;
